import { Field, FieldProps, useFormikContext } from 'formik';

import { FormGroup } from '../form/Form';
import { Switch } from '../switch';

interface IProps {
  name: string;
  label?: string;
  disabled?: boolean;
}

export const FormikSwitchControl = (props: IProps): JSX.Element => {
  const { name, label } = props;
  const form = useFormikContext<Record<string, any>>();

  return (
    <FormGroup labelFor={name}>
      <Field name={name}>
        {(fieldProps: FieldProps) => (
          <Switch
            name={name}
            label={label ?? ''}
            checked={fieldProps.field.value}
            onChange={handleChange}
            large
            id={name}
          />
        )}
      </Field>
    </FormGroup>
  );

  function handleChange() {
    form.setFieldValue(name, !form.values[name]);
    form.setFieldTouched(name, true);
  }
};
